"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountAddress = void 0;
const viem_1 = require("viem");
const getSenderAddress_1 = require("../../../actions/public/getSenderAddress.js");
const getFactoryData_1 = require("./getFactoryData.js");
const getAccountAddress = async (client, { factoryAddress, entryPoint: entryPointAddress, bytes, secp256k1VerificationFacetAddress, index = 0n }) => {
    const factoryData = await (0, getFactoryData_1.getFactoryData)({
        bytes,
        index,
        secp256k1VerificationFacetAddress
    });
    return (0, getSenderAddress_1.getSenderAddress)(client, {
        initCode: (0, viem_1.concatHex)([factoryAddress, factoryData]),
        entryPoint: entryPointAddress
    });
};
exports.getAccountAddress = getAccountAddress;
//# sourceMappingURL=getAccountAddress.js.map